import type { NotificationFormValues } from '@/notificationForms'

import { useCallback } from 'react'

import { updateCanceledNotificationConfig } from '@/features/domain/territory'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useResetEditingState } from '@/atoms'

/**
 * That hook returns a submit method for CanceledNotification Form
 */
export function useCanceledNotificationSubmit() {
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const onDiscard = useResetEditingState()
  const isUnMounted = useIsUnmounted()

  return useCallback(
    async (formValues: NotificationFormValues) => {
      try {
        const result = await dispatch(updateCanceledNotificationConfig(formValues))

        if (!updateCanceledNotificationConfig.fulfilled.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        onDiscard()

        if (isUnMounted()) return
      } catch (error) {
        toast.error(error.message)
      }
    },
    [dispatch, toast],
  )
}
